import { createSelector } from '@ngrx/store';
import { createSortStateSelector } from '../create-sort-state-selector/create-sort-state.selector';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createSortOptionSelector = (filterInstanceId: string) =>
  createSelector(createSortStateSelector(filterInstanceId), (sortState) => {
    return sortState?.sortOptionId;
  });
